// @systeme: interface
// Le lien du courriel de bienvenue : confirme l'adresse, avec ou sans session ouverte.
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Link as LienRouteur, useSearchParams } from 'react-router';
import { messageDe } from '../composants/Messages';
import { api } from '../lib/api';
import { tailles } from '../theme/theme';

export function ConfirmationCourriel() {
  const [parametres] = useSearchParams();
  const jeton = parametres.get('jeton') ?? '';
  // Sans jeton, on le sait dès le rendu : pas besoin d'appeler le serveur.
  const [etat, setEtat] = useState<'en_cours' | 'fait' | string>(
    jeton
      ? 'en_cours'
      : 'Ce lien est incomplet. Depuis l’onglet Moi, tu peux demander un nouveau courriel.',
  );

  useEffect(() => {
    if (!jeton) return;
    api.auth
      .confirmerCourriel(jeton)
      .then(() => setEtat('fait'))
      .catch((e: unknown) => setEtat(messageDe(e)));
  }, [jeton]);

  return (
    <Box sx={{ maxWidth: 480, mx: 'auto', px: `${tailles.marge}px`, pt: 6 }}>
      <Typography variant="h1" component="h1" gutterBottom>
        {etat === 'fait'
          ? 'Adresse confirmée'
          : etat === 'en_cours'
            ? 'Un instant…'
            : 'Ce lien ne marche pas'}
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 3 }}>
        {etat === 'fait'
          ? 'Merci. Tout était déjà en place ; maintenant ton mot de passe se retrouve, et tu peux t’abonner quand tu veux.'
          : etat === 'en_cours'
            ? ''
            : etat}
      </Typography>
      <Button component={LienRouteur} to="/" variant="contained">
        Ouvrir Foyer
      </Button>
    </Box>
  );
}
